/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.rebateCenter = (await import('./pages/RebateCenter')).RebateCenter;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  rebateCenter: {
    name: 'RebateCenter',
    componentName: 'RebateCenter',
    chunk: () => import('./pages/RebateCenter'),
    get component() {
      return ssr
        ? serverPages.rebateCenter
        : currentRouteName === 'RebateCenter'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.RebateCenter })));
    },
    path: '/:context?/rebate-center/index.html',
    varnish: true,
    channel: null
  },
});
